import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import { RouteComponentProps, StaticContext } from 'react-router'
import { useTEPopups } from 'react-tec'

import { signInUser } from './requests'
import {
	PanelWrapper,
	Panel,
	Form,
	Title,
	Input,
	ButtonContainer,
	Forgot,
	Button,
} from './styledComponents'

type Props = RouteComponentProps<{}, StaticContext, { fromPath?: string }>
export const SignIn: React.FC<Props> = (props) => {
	const { history, location } = props

	const popupFunctions = useTEPopups()
	const [email, setEmail] = useState('')
	const [password, setPassword] = useState('')

	const handleSignInSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault()
		const data = {
			email,
			password,
			history,
			fromPath: location?.state?.fromPath,
			popupFunctions,
		}
		signInUser(data)
	}

	const meta = {
		title: 'RCMS Software | Sign In',
		description: 'Standardizing, Digitizing, and Automating',
	}

	return (
		<>
			<Helmet {...meta} />
			<PanelWrapper>
				<Panel>
					<Form onSubmit={handleSignInSubmit}>
						<Title>Sign In</Title>
						<Input
							labelForKey='email'
							type='email'
							placeholder='Email'
							value={email}
							onChange={(e) => setEmail(e.target.value)}
							required
						/>
						<Input
							labelForKey='password'
							type='password'
							placeholder='Password'
							value={password}
							onChange={(e) => setPassword(e.target.value)}
							required
						/>
						<ButtonContainer>
							<Forgot to='/forgot-password'>Forgot Password?</Forgot>
							<Button type='submit'>Sign In</Button>
						</ButtonContainer>
					</Form>
				</Panel>
			</PanelWrapper>
		</>
	)
}
